import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { PrescriptionSide, PrescriptionKey } from '../../../types.js';

const EYE_SIDES = [
    PrescriptionSide.Right,
    PrescriptionSide.Left
];
const dataOrDash = (prescription, key, eye)=>{
    if (!eye) {
        return (prescription === null || prescription === void 0 ? void 0 : prescription[key]) || '-';
    } else {
        var ref;
        return ((ref = prescription[eye]) === null || ref === void 0 ? void 0 : ref[key]) || '-';
    }
};
const CLASS_PREFIX = 'prescription-table';
const isKeyMissing = (prescription, key)=>{
    var ref, ref1;
    return ((ref = prescription.rightEye) === null || ref === void 0 ? void 0 : ref[key]) || ((ref1 = prescription.leftEye) === null || ref1 === void 0 ? void 0 : ref1[key]) || (prescription === null || prescription === void 0 ? void 0 : prescription[key]);
};
const hasEyeSide = (prescription)=>{
    return Boolean(prescription.leftEye || prescription.rightEye);
};
const TableEyeSideTop = ({ keys , prescription , labelFormatter , className , 'aria-label': ariaLabel , size ='normal' ,  })=>{
    const { getLabel  } = useIntl();
    const classes = classnames(className, `${CLASS_PREFIX} ${CLASS_PREFIX}--${size} ${CLASS_PREFIX}--cols-3`);
    return /*#__PURE__*/ React.createElement("table", {
        className: classes,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, ''), hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide)=>/*#__PURE__*/ React.createElement("th", {
            key: `header-${eyeSide}`,
            scope: "col"
        }, getLabel(`products.contactLenses.${eyeSide}`))
    ) : null)), /*#__PURE__*/ React.createElement("tbody", null, keys.map((key)=>isKeyMissing(prescription, key) ? /*#__PURE__*/ React.createElement("tr", {
            key: key
        }, /*#__PURE__*/ React.createElement("th", {
            scope: "row"
        }, labelFormatter(key)), hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide)=>/*#__PURE__*/ React.createElement("td", {
                key: `cell-${eyeSide}-${key}`
            }, dataOrDash(prescription, key, eyeSide))
        ) : /*#__PURE__*/ React.createElement("td", {
            key: `cell-${key}`
        }, prescription && dataOrDash(prescription, key))) : null
    )));
};
const TableEyeSideLeft = ({ keys , prescription , labelFormatter , className , 'aria-label': ariaLabel , size ='normal' ,  })=>{
    const { getLabel  } = useIntl();
    const classes = classnames(className, `${CLASS_PREFIX} ${CLASS_PREFIX}--${size} ${CLASS_PREFIX}--cols-${keys.length + 1}`);
    return /*#__PURE__*/ React.createElement("table", {
        className: classes,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, hasEyeSide(prescription) ? /*#__PURE__*/ React.createElement("td", null, '' /* Add empty string for the top cell above the header column, only show it if we have an eye column */ ) : null, keys.map((key)=>isKeyMissing(prescription, key) ? /*#__PURE__*/ React.createElement("th", {
            key: key,
            scope: "col"
        }, labelFormatter(key)) : null
    ))), /*#__PURE__*/ React.createElement("tbody", null, hasEyeSide(prescription) ? EYE_SIDES.map((eyeSide)=>/*#__PURE__*/ React.createElement("tr", {
            key: `row-${eyeSide}`
        }, /*#__PURE__*/ React.createElement("th", {
            scope: "row"
        }, getLabel(`products.contactLenses.${eyeSide}`)), keys.map((key)=>isKeyMissing(prescription, key) ? /*#__PURE__*/ React.createElement("td", {
                key: key
            }, dataOrDash(prescription, key, eyeSide)) : null
        ))
    ) : keys.map((key)=>isKeyMissing(prescription, key) ? /*#__PURE__*/ React.createElement("td", {
            key: key
        }, dataOrDash(prescription, key)) : null
    )));
};
const PrescriptionTable = (props)=>{
    const { getLabel  } = useIntl();
    const keys = [
        PrescriptionKey.Power,
        PrescriptionKey.BaseCurve,
        PrescriptionKey.Diameter,
        PrescriptionKey.Cylinder,
        PrescriptionKey.Axis,
        PrescriptionKey.Addition,
        PrescriptionKey.PupillaryDistance,
        PrescriptionKey.Prism, 
    ];
    const getAbbreviatedLabel = (propertyName)=>getLabel(`products.contactLenses.prescription.${propertyName}.abbr`)
    ;
    const tableProps = swcHelpers.objectSpread({
        keys,
        labelFormatter: getAbbreviatedLabel
    }, props);
    return props.orientation === 'eyeSideTop' ? /*#__PURE__*/ React.createElement(TableEyeSideTop, swcHelpers.extends({}, tableProps)) : /*#__PURE__*/ React.createElement(TableEyeSideLeft, swcHelpers.extends({}, tableProps));
};
var PrescriptionTable$1 = PrescriptionTable;

export { PrescriptionTable, PrescriptionTable$1 as default };
//# sourceMappingURL=PrescriptionTable.js.map
